<template>
<div id="start" class="hidden-scroll">
    <div class="notive_wrap" autocomplete="new-password">
        <div style="position: absolute;left:-999px;">
            <input type="text" id="tricUser_hp" name="tricUser_hp" autocomplete="off"  placeholder="입력하세요.">
            <input type="password" id="tricPwd" name="tricPwd"  autocomplete="off" placeholder="입력하세요.">
            <input type="password" id="tricPwd1" name="tricPwd1"  autocomplete="off" placeholder="입력하세요.">
        </div>
    </div>
    <!-- 최초 로그인 -->
    <div class="start_bg first_login">
        <div class="logo"><img src="../../assets/image/logo.png" /></div>
        <div class="content-login">
            <div class="input-tag">
                <form id="user_login" action="action/user_login.php" method="post">
                    <div>
                        <input type="text" v-model="user_id" ref='user_id' v-on:focus='inputFocus("user_id")' v-on:input="autoHyphen" class="input-touch" full_length="13" maxlength="13" name="user_hp" value="010" placeholder="휴대폰 번호" pattern="[0-9]*" inputmode="numeric">
                        <input type="password" v-model="user_password" ref='user_password' v-on:focus='inputFocus("user_password")' class="input-touch" full_length="4" maxlength="4" name="user_password" placeholder="비밀번호" pattern="[0-9]*" inputmode="numeric">
                        <div class="loginplus fixedd">
                            <div>
                                <input type="checkbox" id="auto_login" v-model="auto_login_check" class="auto-login"><label for="auto_login">자동로그인</label>
                            </div>
                            <div class="btn-login-service">
                                <!-- <div class="btn-register"><a href="#">회원가입</a></div> -->
                                <div class="find-passwd" @click="password_edit()"><a>비밀번호 찾기</a></div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div id="popup_open" class="btn-login btn01" @click="kiosk_signin()"><a>로그인</a></div>
            <div class="login-info">
                <p>매장 방침에 따라 로그인이 제한될 수 있습니다.<br>
                    구매 및 이용 문의사항은 매장 관리자에게 문의해주세요.</p>
            </div>
        </div>
         <div class="loading" v-show="loading">
            <img src="../../assets/image/loading.gif">
        </div>
    </div>
    <!-- <modals-container /> -->
</div>
</template>

<script>
const FOCUS_TYPE = {
    SIGN_ID: {
        name: 'user_id',
        type: 'KEYBOARD'
    },
    SIGN_PASS: {
        name: 'user_password',
        type: 'KEYBOARD'
    },
}

import vue from 'vue';
// import external from '@/assets/js/external.js';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';
import main from './main'

export default {
    name: 'start',
    data() {
        return {
            loading:false,
            user_id: '010',
            user_password: '',

            // keyboard or num-pad 설정.
            current_focus: null,
            parent_key_str: '',
            store_logo_image : '',

            adv_filename: [],
            playList: [],
            auto_login_check: false
        }
    },
    methods: {
        password_edit(){
            this.$router.push('/password_edit');
        },
        autoHyphen(){
                this.user_id = this.user_id.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");            
        },
        inputFocus(type) {
            const focusObjectList = Object.values(FOCUS_TYPE);
            focusObjectList.forEach(
                (element) => {
                    if (element.name == type) this.current_focus = element;
                }
            );

            this.parent_key_str = this[this.current_focus.name];
        },
        kiosk_signin() {
            this.loading = true;
            if (this.user_id != '' && this.user_password != '') {
                // 로그인하기
                const type = config.REQ_MEMBER_LOGIN;
                const data = {
                    data: {
                        'user_hp': this.user_id,
                        'password': this.user_password
                    }
                }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                    // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.
                }).then((response) => {
                    if(!response.data.result){                        
                        let message = `이용가능한<br>매장이 없습니다.`;
                        this.loading = false;
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: message,
                        };
                        this.$store.commit('set_popup_type', alert_param);
                    }else{
                        // 이용제한 사용자 입니다. 관리자에게 문의하세요.
                        if (response.result && response.data.userInfo.blacklist_yn != 1) {
                            this.$store.commit('set_user', {
                                user: response.data.userInfo
                            });

                            this.$store.commit('set_store_list', { 
                                store_list: response.data.storeList
                            });
                            //this.$store.state.login_chk = true;
                            this.$store.commit('change_login_chk', {
                                value: true
                            });
                            this.$store.commit('set_Item_register_info', {
                                id:'',
                                pass:'',
                                flag:false
                            });

                            var router = this.$router;
                            var last_url = this.$store.getters['get_last_url'];
                            if (last_url == undefined ||
                                last_url == null ||
                                last_url == '' ||
                                last_url == 'undefined' ||
                                last_url == 'null' ||
                                last_url.length == 0) {
                                // router.push('/');
                                if(!response.data.default_store_yn){                                
                                    router.push('/store');
                                }else{
                                    // router.push('/');
                                    
                                    let that = this;
                                    return new Promise(function(resolve, reject){
                                        resolve(resolve);
                                    })
                                    .then(result => {
                                        this.$store.commit('set_store_info', {
                                            store_info: response.data.storeInfo
                                        });
                                        this.$store.commit('change_main_start_chk', {
                                            value: true
                                        });
                                        return this.$store.dispatch(config.ACT_GET_INIT_DATA);
                                    })
                                    .then(result => {
                                        this.loading = false;
                                        this.$store.commit('set_page_header_init', {
                                            style: 'block'
                                        });                                    
                                        this.$router.push('/front_main');
                                    })
                                    .then(()=> {
                                        // 자동 로그인 시 안드로이드에 아이디와 비밀번호 저장
                                        if(this.auto_login_check){
                                            let params = {};
                                            params.user_id = this.user_id;
                                            params.password = this.user_password;
                                            // params.autoCheck = this.auto_login_check;

                                            var paramData = JSON.stringify(params);

                                            window.android.kioskAutoLogin(paramData);
                                        }else{
                                            window.android.kioskRemoveAutoLogin();
                                        }
                                    });
                                }
                            } else {                           
                                router.push(last_url); // 이동 위치를 입력
                            }
                        } else {
                            // 로그인 실패
                            // this.$refs.user_id.focus();
                            let message = ``;
                            if(!response.result){
                                message = `휴대폰번호가 존재하지않거나 비밀번호가 일치하지 않습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`;
                            }else{
                                if (response.data.userInfo.blacklist_yn == 1) message = `이용제한 사용자 입니다.</span><br /><br /><span>관리자에게 문의하세요.`;
                            }

                            this.loading = false;
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: message,
                                router: '/login',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return Promise.reject();
                        }                        
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            } else {
                this.$store.state.login_chk = true;
                this.$store.commit('change_login_chk', {
                    value: true
                });

                let message = `휴대폰번호 또는 비밀번호가 입력되지 않았습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`;
                this.loading = false;
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: message,
                    router: '/login',
                };
                this.$store.commit('set_popup_type', alert_param);

                // var router = this.$router;
                // router.push('/') // 이동 위치를 입력   
            }
        },
        popup_message(message){
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: message,
                router: '/login',
            };
            this.$store.commit('set_popup_type', alert_param);
        },
        register_modal_pop() {
            var router = this.$router;
            router.push('/register') // 이동 위치를 입력
        },
    },
    mounted() {
        this.$nextTick(function () {
            // store_logo_image
            var temp_store_main_image = this.$store.getters['getStoreInfo']['store_img'];
            if(typeof temp_store_main_image == 'undefined' || temp_store_main_image == ''){
                temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/logo.png';
            }else{
                temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/'+temp_store_main_image;
            }
            this.store_main_image = temp_store_main_image;
            this.logo_width_size = this.$store.getters['getStoreInfo'].logo_width_size;
            this.logo_height_size = this.$store.getters['getStoreInfo'].logo_height_size;

            this.store_bg_image = this.$store.getters['get_store_bg_img_url'];

            this.$store.commit('set_Last_URL', '');
            
            // 로그인 초기값 설정.
            this.sign_id = '010';
            this.sign_password = '';

        });

    },
    watch:{
        user_id(){       
            if(this.user_id.length == 13){
                document.getElementsByName('user_password')[0].focus();
            }
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/page/start.vue